/**
 * @param {string} sku
 */
function isReplacement(sku) {
  const skuUpper = sku.toUpperCase();
  return skuUpper.endsWith('REPLACEMENT') || skuUpper.endsWith('REPLACE') || skuUpper.includes('REFURB');
}

module.exports = {
  isReplacement,
};
